import React from 'react';
import { Category } from '@/types';
import { ChevronRight } from 'lucide-react';

interface CategoryPathDisplayProps {
  category: Category;
}

export const CategoryPathDisplay: React.FC<CategoryPathDisplayProps> = ({ category }) => {
  console.log('Rendering CategoryPathDisplay for category:', category.name);
  
  const findCategoryPath = (cat: Category): string[] => {
    const path: string[] = [cat.name];
    let currentCat = cat;
    
    while (currentCat.parentId) {
      const parent = findParentCategory(currentCat.parentId);
      if (parent) {
        path.unshift(parent.name);
        currentCat = parent;
      } else {
        break;
      }
    }
    
    return path;
  };

  const findParentCategory = (parentId: string): Category | null => {
    const findInCategories = (categories: Category[]): Category | null => {
      for (const cat of categories) {
        if (cat.id === parentId) {
          return cat;
        }
        if (cat.children.length > 0) {
          const found = findInCategories(cat.children);
          if (found) return found;
        }
      }
      return null;
    };

    const rootCategories = ((window as unknown) as Record<string, unknown>).__CATEGORIES__ as Category[] || [];
    return findInCategories(rootCategories);
  };

  const categoryPath = findCategoryPath(category);

  return (
    <div className="space-y-2">
      <h3 className="text-lg font-semibold" style={{ color: '#FF6D00' }}>
        {category.name}
      </h3>
      <div className="flex flex-col space-y-0.5">
        {categoryPath.map((name, index) => (
          <div 
            key={index}
            className="flex items-center text-sm text-gray-800"
            style={{ paddingLeft: `${index * 16}px` }}
          >
            <ChevronRight className="h-3 w-3 text-gray-400 mr-1" />
            <span className="font-medium">{name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};